import { fetchGlobalParticipatedAds } from './methods'
import { globalParticipatedAdQueryOptions } from './options'

export { fetchGlobalParticipatedAds, globalParticipatedAdQueryOptions }
